import React, { useState, useEffect } from "react";

const CookiesModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem("cookiesAccepted");
    if (!cookiesAccepted) {
      setTimeout(() => {
        setIsVisible(true);
      }, 4000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookies" style={styles.overlay}>
      <div style={styles.modal}>
        <button onClick={handleClose} style={styles.closeButton}>
          ×
        </button>
        <h2>Ova veb stranica koristi kolačiće</h2>
        <p>
          Koristimo kolačiće za poboljšanje korisničkog iskustva na našoj veb
          stranici. Prihvatanjem kolačića, pristajete na njihovu upotrebu.
        </p>
        <div className="btns-cookies" style={styles.buttonContainer}>
          <button onClick={handleAccept} style={styles.acceptButton}>
            Prihvatam
          </button>
          <a
            href="/politika-privatnosti"
            style={styles.policyLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Pročitaj politiku privatnosti
          </a>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
  },
  modal: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
    width: "80%",
    maxWidth: "500px",
    position: "relative"
  },
  closeButton: {
    position: "absolute",
    top: "0px",
    right: "0px",
    color: "#000",
    background: "transparent",
    border: "none",
    fontSize: "30px",
    cursor: "pointer"
  },
  buttonContainer: {
    marginTop: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "30px"
  },
  acceptButton: {
    padding: "10px 30px",
    backgroundColor: "var(--primary-color)",
    color: "white",
    border: "none",
    fontSize: "14px",
    borderRadius: "30px",
    cursor: "pointer"
  },
  policyLink: {
    padding: "10px",
    textDecoration: "none",
    color: "#007bff",
    fontSize: "14px",
    cursor: "pointer"
  }
};

export default CookiesModal;
